import styled from 'styled-components';

import { Checkmark } from '../Common.styled';

export const StyledCheckmark = styled(Checkmark)(({ theme: { size } }) => ({
  width: size.units(1.25),
  height: size.units(1.25),
  borderRadius: size.units(0.25),

  '&:after': {
    width: size.units(0.75),
    height: size.units(0.75),
  },
}));
